import { __decorate } from "tslib";
import { inject, observer } from "mobx-react";
import React from "react";
import { BaseComponent } from "../../../components/base";
import { TeacherGroupTabComponent } from "./teacher-group-tab";
import { TeacherStudentTabComponent } from "./teacher-student-tab";
import "./teacher-dashboard.scss";
const tabs = [
    { type: "Groups", id: "groups" },
    // TODO: add back tab when support stories (#160073804 && 160073880) are worked on
    // {type: "Supports", id: "supports"}
];
let TeacherDashboardComponent = class TeacherDashboardComponent extends BaseComponent {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                activeTab: tabs[0]
            }
        });
    }
    render() {
        const { activeTab } = this.state;
        return (React.createElement("main", { id: "main-dashboard", className: "teacher-dashboard", tabIndex: -1 },
            React.createElement("div", { className: "tabbed-area" },
                React.createElement("div", { className: "tab-contents", "aria-labelledby": this.getTabId(activeTab) }, this.renderTabContents()))));
    }
    renderTabContents() {
        switch (this.state.activeTab.type) {
            case "Groups":
                return (React.createElement("div", { className: "contents" },
                    React.createElement(TeacherGroupTabComponent, null)));
            case "Students":
                return (React.createElement("div", { className: "contents" },
                    React.createElement(TeacherStudentTabComponent, null)));
            case "Supports":
                return (React.createElement("div", { className: "contents" }, "TBD: Supports"));
        }
    }
    getTabId(tab) {
        return `teacher-dashboard-${tab.id}`;
    }
};
TeacherDashboardComponent = __decorate([
    inject("stores"),
    observer
], TeacherDashboardComponent);
export { TeacherDashboardComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVhY2hlci1kYXNoYm9hcmQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY2x1ZS9jb21wb25lbnRzL3RlYWNoZXIvdGVhY2hlci1kYXNoYm9hcmQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUUsTUFBTSxFQUFFLFFBQVEsRUFBRSxNQUFNLFlBQVksQ0FBQztBQUM5QyxPQUFPLEtBQUssTUFBTSxPQUFPLENBQUM7QUFDMUIsT0FBTyxFQUFFLGFBQWEsRUFBYyxNQUFNLDBCQUEwQixDQUFDO0FBQ3JFLE9BQU8sRUFBRSx3QkFBd0IsRUFBRSxNQUFNLHFCQUFxQixDQUFDO0FBQy9ELE9BQU8sRUFBRSwwQkFBMEIsRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBQ25FLE9BQU8sMEJBQTBCLENBQUM7QUFjbEMsTUFBTSxJQUFJLEdBQWM7SUFDdEIsRUFBQyxJQUFJLEVBQUUsUUFBUSxFQUFFLEVBQUUsRUFBRSxRQUFRLEVBQUM7SUFDOUIsa0ZBQWtGO0lBQ2xGLHFDQUFxQztDQUN0QyxDQUFDO0FBSUssSUFBTSx5QkFBeUIsR0FBL0IsTUFBTSx5QkFBMEIsU0FBUSxhQUE2QjtJQUFyRTs7UUFFRTs7OzttQkFBZ0I7Z0JBQ3JCLFNBQVMsRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDO2FBQ25CO1dBQUM7SUEwQ0osQ0FBQztJQXhDUSxNQUFNO1FBQ1gsTUFBTSxFQUFDLFNBQVMsRUFBQyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUM7UUFFL0IsT0FBTyxDQUNMLDhCQUFNLEVBQUUsRUFBQyxnQkFBZ0IsRUFBQyxTQUFTLEVBQUMsbUJBQW1CLEVBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQztZQUNsRSw2QkFBSyxTQUFTLEVBQUMsYUFBYTtnQkFDMUIsNkJBQUssU0FBUyxFQUFDLGNBQWMscUJBQWtCLElBQUksQ0FBQyxRQUFRLENBQUMsU0FBUyxDQUFDLElBQ3BFLElBQUksQ0FBQyxpQkFBaUIsRUFBRSxDQUNyQixDQUNGLENBQ0QsQ0FDUixDQUFDO0lBQ0osQ0FBQztJQUVPLGlCQUFpQjtRQUN2QixRQUFRLElBQUksQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLElBQUksRUFBRSxDQUFDO1lBQ2xDLEtBQUssUUFBUTtnQkFDWCxPQUFPLENBQ0wsNkJBQUssU0FBUyxFQUFDLFVBQVU7b0JBQ3ZCLG9CQUFDLHdCQUF3QixPQUFHLENBQ3hCLENBQ1AsQ0FBQztZQUNKLEtBQUssVUFBVTtnQkFDYixPQUFPLENBQ0wsNkJBQUssU0FBUyxFQUFDLFVBQVU7b0JBQ3ZCLG9CQUFDLDBCQUEwQixPQUFHLENBQzFCLENBQ1AsQ0FBQztZQUNKLEtBQUssVUFBVTtnQkFDYixPQUFPLENBQ0wsNkJBQUssU0FBUyxFQUFDLFVBQVUsb0JBRW5CLENBQ1AsQ0FBQztRQUNOLENBQUM7SUFDSCxDQUFDO0lBRU8sUUFBUSxDQUFDLEdBQVk7UUFDM0IsT0FBTyxxQkFBcUIsR0FBRyxDQUFDLEVBQUUsRUFBRSxDQUFDO0lBQ3ZDLENBQUM7Q0FDRixDQUFBO0FBOUNZLHlCQUF5QjtJQUZyQyxNQUFNLENBQUMsUUFBUSxDQUFDO0lBQ2hCLFFBQVE7R0FDSSx5QkFBeUIsQ0E4Q3JDIn0=